// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-block[data-v-f050ff34] {\n    max-height: inherit;\n    font-size: 0;\n}\n.inline_video_container[data-v-f050ff34] {\n    width: 100%;\n    vertical-align: middle;\n    display: inline-block;\n    height: 100%;\n    max-height: inherit;\n    /*max-height: min(100%, 450px);*/\n}\n", ""]);
// Exports
module.exports = exports;
